import React from 'react';
import { Home, ArrowsMaximize, Box, DoorOpen } from 'lucide-react';

const RoomParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  roomTypes
}) => {
  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Home className="w-5 h-5 mr-2 text-blue-500" />
        Параметры помещения
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Тип помещения */}
        <div>
          <label htmlFor="roomType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип помещения
          </label>
          <select
            id="roomType"
            name="roomType"
            value={formData.roomType}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.roomType ? 'input-error' : ''}`}
          >
            {roomTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
          {errors.roomType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.roomType}
            </p>
          )}
        </div>

        {/* Высота стен */}
        <div>
          <label htmlFor="wallsHeight" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Высота стен (м)
          </label>
          <div className="relative">
            <input
              type="text"
              id="wallsHeight"
              name="wallsHeight"
              value={formData.wallsHeight}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.roomLength ? 'input-error' : ''}`}
              placeholder="Длина комнаты"
            />
            <span className="absolute inset-y-0 right-3 flex items-center text-gray-500 dark:text-gray-400 pointer-events-none">
              м
            </span>
          </div>
          {errors.roomLength && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.roomLength}
            </p>
          )}
        </div>

        {/* Ширина комнаты */}
        <div>
          <label htmlFor="roomWidth" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Ширина (м)
          </label>
          <div className="relative">
            <input
              type="text"
              id="roomWidth"
              name="roomWidth"
              value={formData.roomWidth}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.roomWidth ? 'input-error' : ''}`}
              placeholder="Ширина комнаты"
            />
            <span className="absolute inset-y-0 right-3 flex items-center text-gray-500 dark:text-gray-400 pointer-events-none">
              м
            </span>
          </div>
          {errors.roomWidth && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.roomWidth}
            </p>
          )}
        </div>

        {/* Окна - заголовок */}
        <div className="md:col-span-2 mt-2">
          <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 flex items-center mb-2">
            <Box className="w-4 h-4 mr-2 text-blue-500" />
            Окна в помещении
          </h4>
        </div>

        {/* Количество окон */}
        <div>
          <label htmlFor="windowsNumber" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Количество окон
          </label>
          <input
            type="number"
            id="windowsNumber"
            name="windowsNumber"
            value={formData.windowsNumber}
            onChange={handleInputChange}
            min="0"
            className={`form-input w-full ${errors.windowsNumber ? 'input-error' : ''}`}
            placeholder="0"
          />
          {errors.windowsNumber && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.windowsNumber}
            </p>
          )}
        </div>

        {parseInt(formData.windowsNumber) > 0 && (
          <>
            {/* Размеры окна */}
            <div className="flex gap-2">
              <div className="flex-1">
                <label htmlFor="windowHeight" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Высота (м)
                </label>
                <div className="relative">
                  <input
                    type="text"
                    id="windowHeight"
                    name="windowHeight"
                    value={formData.windowHeight}
                    onChange={handleInputChange}
                    className={`form-input w-full ${errors.windowHeight ? 'input-error' : ''}`}
                    placeholder="1.5"
                  />
                  <span className="absolute inset-y-0 right-2 flex items-center text-gray-500 dark:text-gray-400 pointer-events-none">
                    м
                  </span>
                </div>
                {errors.windowHeight && (
                  <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                    {errors.windowHeight}
                  </p>
                )}
              </div>
              <div className="flex-1">
                <label htmlFor="windowWidth" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Ширина (м)
                </label>
                <div className="relative">
                  <input
                    type="text"
                    id="windowWidth"
                    name="windowWidth"
                    value={formData.windowWidth}
                    onChange={handleInputChange}
                    className={`form-input w-full ${errors.windowWidth ? 'input-error' : ''}`}
                    placeholder="1.2"
                  />
                  <span className="absolute inset-y-0 right-2 flex items-center text-gray-500 dark:text-gray-400 pointer-events-none">
                    м
                  </span>
                </div>
                {errors.windowWidth && (
                  <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                    {errors.windowWidth}
                  </p>
                )}
              </div>
            </div>
          </>
        )}

        {/* Двери - заголовок */}
        <div className="md:col-span-2 mt-2">
          <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 flex items-center mb-2">
            <DoorOpen className="w-4 h-4 mr-2 text-blue-500" />
            Двери в помещении
          </h4>
        </div>

        {/* Количество дверей */}
        <div>
          <label htmlFor="doorsNumber" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Количество дверей
          </label>
          <input
            type="number"
            id="doorsNumber"
            name="doorsNumber"
            value={formData.doorsNumber}
            onChange={handleInputChange}
            min="0"
            className={`form-input w-full ${errors.doorsNumber ? 'input-error' : ''}`}
            placeholder="0"
          />
          {errors.doorsNumber && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.doorsNumber}
            </p>
          )}
        </div>

        {parseInt(formData.doorsNumber) > 0 && (
          <>
            {/* Размеры двери */}
            <div className="flex gap-2">
              <div className="flex-1">
                <label htmlFor="doorHeight" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Высота (м)
                </label>
                <div className="relative">
                  <input
                    type="text"
                    id="doorHeight"
                    name="doorHeight"
                    value={formData.doorHeight}
                    onChange={handleInputChange}
                    className={`form-input w-full ${errors.doorHeight ? 'input-error' : ''}`}
                    placeholder="2.0"
                  />
                  <span className="absolute inset-y-0 right-2 flex items-center text-gray-500 dark:text-gray-400 pointer-events-none">
                    м
                  </span>
                </div>
                {errors.doorHeight && (
                  <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                    {errors.doorHeight}
                  </p>
                )}
              </div>
              <div className="flex-1">
                <label htmlFor="doorWidth" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Ширина (м)
                </label>
                <div className="relative">
                  <input
                    type="text"
                    id="doorWidth"
                    name="doorWidth"
                    value={formData.doorWidth}
                    onChange={handleInputChange}
                    className={`form-input w-full ${errors.doorWidth ? 'input-error' : ''}`}
                    placeholder="0.9"
                  />
                  <span className="absolute inset-y-0 right-2 flex items-center text-gray-500 dark:text-gray-400 pointer-events-none">
                    м
                  </span>
                </div>
                {errors.doorWidth && (
                  <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                    {errors.doorWidth}
                  </p>
                )}
              </div>
            </div>
          </>
        )}
      </div>

      <div className="mt-4 bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
        <div className="flex items-start">
          <Home className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Как считается площадь стен
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Площадь рассчитывается из высоты стен и периметра помещения, с учетом вычета площади окон и дверей.
              Если включен потолок, его площадь добавляется к общей площади покраски.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomParametersSection;